import { render, staticRenderFns } from "./AuthForgot.vue?vue&type=template&id=b9b7e254&"
import script from "./AuthForgot.vue?vue&type=script&lang=js&"
export * from "./AuthForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports